import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  style: {"scrollbar-width":"thin"},
  class: "w-full h-full bg-[#3a414a] vScore overflow-y-auto"
}
const _hoisted_2 = { class: "mt-14 p-4" }
const _hoisted_3 = { class: "flex justify-center mb-2 mt-1" }
const _hoisted_4 = {
  key: 0,
  class: "flex"
}
const _hoisted_5 = {
  key: 0,
  class: "matchSelect w-full"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-center font-bold text-lg mb-2" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex flex-col w-2/3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex flex-col w-1/3 min-w-min items-end" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = {
  key: 1,
  class: "w-full flex pb-10"
}

import { ref, Ref, onMounted } from 'vue'
import { Match } from '@/models/vscoreModels'
import ProgressSpinner from 'primevue/progressspinner'
import { useRealtimeApiStore } from "../store/api/realtimeApi"
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputGroup from 'primevue/inputgroup';
import { useRouter } from 'vue-router'

const typingTime = 200;


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchSelectorView',
  setup(__props) {

const router = useRouter()

const api = useRealtimeApiStore();

const state = ref({
    isLoading: true,
    isMatchSelected: false,
})

const data: Ref<Match[]> = ref([])

const selectedMatch: Ref<Match> = ref(<Match>{});

const searchedData: Ref<Match[]> = ref([])
const offset = ref(0)
const limit = ref(50)
const searchText = ref("")
let typingTimer: any;
onMounted(async () => {
    state.value.isLoading = true

    await api.getAllMatches().then((value) => {
        data.value = value.data;
        createMatchName()
    })

    // for (let index = 0; index < 20; index++) {
    //     data.value.push(data.value[0])
    // }

    searchData()
    state.value.isLoading = false

})

function searchData() {
    searchedData.value = []
    if (searchText.value != '') {
        searchedData.value = data.value.filter((o: any) => o["name"].toUpperCase().includes(searchText.value.toUpperCase())) as []

    } else {
        searchedData.value = data.value as []
    }
    searchedData.value
    return searchedData
}

function matchSelected(match: Match) {
    selectedMatch.value = match;
    state.value.isMatchSelected = true
}

function clearTimer() {
    clearTimeout(typingTimer)
}

function startTimer() {
    clearTimeout(typingTimer)
    offset.value = 0
    typingTimer = setTimeout(searchData, typingTime)
}

function createMatchName() {
    data.value = data.value.map(function (el: any) {
        el.name = (el.team1.team.name + " vs " + el.team2.team.name + " at " + el.venue.name + " on " + (new Date(el.startDate)).toUTCString());
        return el as never;
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(InputGroup), { class: "max-w-80" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InputText), {
              modelValue: searchText.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
              placeholder: "Search",
              id: "searchInput",
              onKeydown: clearTimer,
              onKeyup: startTimer,
              class: "text-center rounded-l-md border-2 shadow-none min-w-fit h-6 text-black-900 w-60 border-r-0 bg-white"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(Button), {
              icon: "pi pi-search",
              class: "bg-[#1f2937] hover:bg-slate-500 text-white font-semi h-6 py-0 px-2 rounded-r"
            })
          ]),
          _: 1
        })
      ]),
      (!state.value.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (searchedData.value.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchedData.value, (match) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: match.id,
                      onClick: ($event: any) => {matchSelected(match); _unref(router).push('/vscore?q=' + match.id)},
                      class: "ml-0.5 mr-0.5 p-4 mt-1 rounded bg-[#1f2937] text-[#dcdde0] items-center flex flex-col hover:border hover:cursor-pointer max-w-[450px] min-w-min float-left"
                    }, [
                      _createElementVNode("ul", _hoisted_7, [
                        _createElementVNode("li", _hoisted_8, [
                          _createElementVNode("span", null, _toDisplayString(match.team1.team.name) + " v " + _toDisplayString(match.team2.team.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("span", null, _toDisplayString(match.venue.name), 1),
                            _createElementVNode("span", null, _toDisplayString(match.venue.city) + " | " + _toDisplayString(match.venue.country), 1),
                            (match.series)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(match.series.name), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", null, _toDisplayString(match.matchType), 1),
                            _createElementVNode("span", null, _toDisplayString(match.season), 1),
                            _createElementVNode("span", null, _toDisplayString(match.gender), 1)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(new Date(match.startDate).toISOString().split('T')[0]), 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(new Date(match.startDate).toISOString().split('T')[1].slice(0, 5)), 1)
                          ])
                        ])
                      ])
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_unref(ProgressSpinner), {
              class: "justify-center w-90 h-90",
              "attrs-color-black": "",
              strokeWidth: "5",
              animationDuration: "1s",
              "aria-label": "Loading"
            })
          ]))
    ])
  ]))
}
}

})